import { SUPPORTED_LOCALES } from './locale';
import { i18nService } from './I18nService';
import { authService } from '../auth/AuthService';
import { updateProfileLocale } from '../api/profileApi';
const LOCALE_LABELS = {
    ru: 'RU',
    en: 'EN',
    gr: 'GR'
};
export function createLanguageSwitcher() {
    let current = i18nService.getLocale();
    const root = document.createElement('div');
    root.className = 'lang-switch';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'lang-switch__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Choose language');
    const list = document.createElement('ul');
    list.className = 'lang-switch__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    function setOpen(open) {
        list.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
    }
    function renderOptions() {
        list.innerHTML = '';
        for (const locale of SUPPORTED_LOCALES) {
            const item = document.createElement('li');
            item.setAttribute('role', 'presentation');
            const option = document.createElement('button');
            option.type = 'button';
            option.className = 'lang-switch__option';
            option.classList.toggle('lang-switch__option--active', locale === current);
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', String(locale === current));
            option.textContent = LOCALE_LABELS[locale];
            option.addEventListener('click', () => {
                setOpen(false);
                if (locale === current)
                    return;
                current = locale;
                button.textContent = LOCALE_LABELS[current];
                renderOptions();
                i18nService.changeLanguage(locale);
                if (authService.isAuthorized) {
                    updateProfileLocale(locale).catch((error) => {
                        console.error('Failed to persist locale:', error);
                    });
                }
            });
            item.appendChild(option);
            list.appendChild(item);
        }
    }
    button.textContent = LOCALE_LABELS[current];
    button.addEventListener('click', (event) => {
        event.stopPropagation();
        setOpen(list.hidden);
    });
    document.addEventListener('click', (event) => {
        if (!root.contains(event.target))
            setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape')
            setOpen(false);
    });
    renderOptions();
    root.append(button, list);
    return root;
}
